import React, { useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import themeDefault from './default';

/**
 * WhitelabelThemeProvider
 * 
 * Este componente gerencia o tema dinâmico da aplicação, combinando as configurações
 * recebidas (whitelabel) com um tema padrão (fallback).
 * 
 * @param {Object} whitelabel - Objeto de configuração da marca (cores, fontes, logos, etc).
 * @param {React.ReactNode} children - Componentes filhos que terão acesso ao tema.
 */
const WhitelabelThemeProvider = ({ whitelabel, children }) => {
  // Combina o objeto whitelabel com o themeDefault
  const theme = {
    ...themeDefault,
    whitelabel: {
      ...themeDefault.whitelabel,
      ...whitelabel,
    },
  };

  useEffect(() => {
    if (whitelabel) {
      // Atualiza o título da página se disponível
      if (whitelabel.page_title) {
        document.title = whitelabel.page_title;
      }

      // Atualiza o favicon se disponível
      if (whitelabel.favicon_url) {
        let link = document.querySelector("link[rel*='icon']");
        if (!link) {
          link = document.createElement('link');
          link.rel = 'shortcut icon';
          document.getElementsByTagName('head')[0].appendChild(link);
        }
        link.href = whitelabel.favicon_url;
      }
    }
  }, [whitelabel]);

  return (
    <ThemeProvider theme={theme}>
      {children}
    </ThemeProvider>
  );
};

export default WhitelabelThemeProvider;
